document.addEventListener('DOMContentLoaded', function () {
  // nespusti se vubec na mobilu (preload obrazku - zpomaluje)
  // kontroluje, zda se zvetsilo okno a pokud ano, nacte se
  const desktopQuery = window.matchMedia("(min-width: 992px)");
  let menuInitialized = false;

  function initMegaMenu() {

    if (menuInitialized) return;
    if (!desktopQuery.matches) return;

    menuInitialized = true;

    // ===== původní kód začíná tady =====

    function waitForJsonElement(selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const interval = 100;
        const start = Date.now();

        const check = () => {
          const el = document.querySelector(selector);
          if (el) return resolve(el);
          if (Date.now() - start >= timeout) return reject(new Error('⛔ JSON <script> nenalezen'));
          setTimeout(check, interval);
        };
        check();
      });
    }

    waitForJsonElement('#menu-data', 8000)
    .then(menuDataEl => {
      let menuJson;
      try {
        menuJson = JSON.parse(menuDataEl.textContent);
      } catch (e) {
        console.error('❌ Chyba při parsování JSON:', e);
        return;
      }

      const menuItems = menuJson.menu;
      if (!Array.isArray(menuItems) || !menuItems.length) {
        console.warn('⚠️ Žádná položka menu ve `menuJson.menu`');
        return;
      }

      const replayMenu = document.createElement('div');
      replayMenu.className = 'replay-megamenu-root header__nav';

      const topUl = document.createElement('ul');
      topUl.className = 'replay-top-level';

      const imgMap = menuJson.images || {};

      //to prevent flickering when hovering for the first time
      function preloadMenuImages(map) {
        const loaded = {};

        Object.values(map).forEach(src => {
          if (!src || loaded[src]) return;

          const img = new Image();
          img.src = src;

          loaded[src] = true;
        });

        console.log('🖼️ Mega menu images preloaded');
      }

      preloadMenuImages(imgMap);

      function createMenuItem(title, url) {
        const a = document.createElement('a');
        a.href = url || '#';
        a.textContent = title;
        return a;
      }

      function createThirdLevel(thirdItems) {
        const wrapper = document.createElement('div');
        wrapper.className = 'replay-third-panel';

        const ul = document.createElement('ul');

        if (Array.isArray(thirdItems)) {
          thirdItems.forEach(item => {
            const li = document.createElement('li');
            li.appendChild(createMenuItem(item.title, item.url));
            ul.appendChild(li);
          });
        }

        wrapper.appendChild(ul);
        return wrapper;
      }

      menuItems.forEach(topItem => {
        const topLi = document.createElement('li');
        topLi.className = 'replay-menu-item';





        // seznam odkazů, které mají být jen na mobilu
        const hiddenOnDesktop = [
          '/pages/kontakt',
          '/pages/vernostni-sleva'
        ];

        if (hiddenOnDesktop.includes(topItem.url)) {
          topLi.style.display = "none"; // hned schovat
          topLi.classList.add("mobile-only"); // pro přepis v CSS na mobilech
          topLi.classList.add('mobile-only');
        }





        topLi.appendChild(createMenuItem(topItem.title, topItem.url));

        if (Array.isArray(topItem.children) && topItem.children.length > 0) {
          const submenuWrapper = document.createElement('div');
          submenuWrapper.className = 'replay-submenu';

          const submenuUl = document.createElement('ul');
          submenuUl.className = 'replay-submenu-links';

          const imgDiv = document.createElement('div');
          imgDiv.className = 'submenu-image';

          const firstChild = topItem.children[0];
          const imgKey = `${topItem.title}|${firstChild.title}`;
          const imgSrc = imgMap[topItem.title];

          const menuImg = document.createElement('img');
          menuImg.className = 'submenu-main-image';
          menuImg.alt = topItem.title;

          if (imgSrc) {
            menuImg.src = imgSrc;
          }

          if (topItem.url && !topItem.url.includes('#')) {
            const imageLink = document.createElement('a');
            imageLink.href = topItem.url;
            imageLink.className = 'submenu-image-link';
            imageLink.setAttribute('aria-label', topItem.title);
            imageLink.appendChild(menuImg);
            imgDiv.appendChild(imageLink);
          } else {
            imgDiv.appendChild(menuImg);
          }

          topItem.children.forEach(subItem => {

            const column = document.createElement('div');
            column.className = 'replay-column';

            const title = document.createElement('a');
            title.href = subItem.url || '#';
            title.textContent = subItem.title;
            title.className = 'replay-column-title';

            column.appendChild(title);

            // === HOVER → ZMĚNA OBRÁZKU ===
            column.addEventListener('mouseenter', () => {
              const key = `${topItem.title}|${subItem.title}`;
              const hoverImg = imgMap[key];

              if (!hoverImg) return;
              if (menuImg.src === hoverImg) return;

              menuImg.classList.add('is-changing');

              menuImg.onload = () => {
                menuImg.classList.remove('is-changing');
              };

              menuImg.src = hoverImg;
              menuImg.alt = subItem.title;

            });

            // children links
            if (Array.isArray(subItem.children)) {
              const ul = document.createElement('ul');

              subItem.children.forEach(child => {
                const li = document.createElement('li');
                li.appendChild(createMenuItem(child.title, child.url));
                ul.appendChild(li);
              });

              column.appendChild(ul);
            }

            submenuUl.appendChild(column);
          });

          submenuWrapper.appendChild(submenuUl);
          submenuWrapper.appendChild(imgDiv);

          topLi.appendChild(submenuWrapper);
        }

        topUl.appendChild(topLi);
      });

      replayMenu.appendChild(topUl);

      const oldNav = document.querySelector('.header__nav');
      if (oldNav) oldNav.replaceWith(replayMenu);
      else document.body.appendChild(replayMenu);

      console.log('%c✅ Menu úspěšně vygenerováno z JSON!', 'color: green; font-weight: bold');

      // === Delay pro submenu (aby hned nemizelo) ===
      document.querySelectorAll('.replay-menu-item').forEach(item => {
        let hideTimeout;

        item.addEventListener('mouseenter', () => {
          clearTimeout(hideTimeout);
          item.classList.add('open');
        });

        item.addEventListener('mouseleave', () => {
          hideTimeout = setTimeout(() => {
            item.classList.remove('open');
          }, 300); // nastav si delay v ms (200–400 je ideál)
        });
      });

      // === Zvýraznění aktivní položky podle URL ===
      (function highlightActiveLinks() {
        const currentPath = window.location.pathname.replace(/\/$/, ""); 
        const links = document.querySelectorAll('.replay-megamenu-root a');

        links.forEach(link => {
          let linkPath = link.getAttribute('href');
          if (!linkPath) return;

          linkPath = linkPath.split("?")[0].replace(/\/$/, "");

          if (linkPath === currentPath) {
            // aktivovat samotný link
            link.classList.add("active");

            // projít všechny rodiče až k top-level
            let el = link.parentElement;
            while (el && !el.classList.contains('replay-megamenu-root')) {
              if (el.tagName === 'LI') {
                const a = el.querySelector('a');
                if (a) a.classList.add('active');
              }
              el = el.parentElement;
            }
          }
        });
      })();



    })
    .catch(err => {
      console.error('❌ Menu data nebyla nalezena nebo se načetla příliš pozdě:', err);
    });
  }
    
  // první load
  initMegaMenu();

  // když se okno zvětší na desktop
  desktopQuery.addEventListener("change", function(e) {
    if (e.matches) {
      initMegaMenu();
    }
  });
});